<template>
    <div class="left" style="width: 100%; height: 100%">
        <div
            :class="[clickflag ? 'clicktruediv' : 'clickfalsediv']"
            @click="clickflaghandle"
        >
            <span
                :class="[clickflag ? 'clicktruespan' : 'clickfalsespan']"
                style="font-size: larger"
                >聚落定位</span
            >
            <el-image
                style="width: 12px; height: 8px"
                :src="
                    clickflag
                        ? '/static/images/定位-箭头向上.png'
                        : '/static/images/定位箭头-向下.png'
                "
            ></el-image>
        </div>
        <!-- :class="{ noSide: noSide }" -->
        <div
            :class="[clickflag ? 'menu ' : 'menu noSide ']"
            style="
                width: 630px;
                height: 685px;
                opacity: 0.95;
                background: #ffffff;
                box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.12);
                border-radius: 0px 4px 4px 4px;
                padding-top: 20px;
                padding-left: 30px;
            "
        >
           

            <el-row
                style="
                    width: 600px;
                    height: 48px;
                    background: #ffffff;
                    border-radius: 4px 0px 0px 4px;
                    box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.2);
                "
            >
                <el-input
                    placeholder="输入聚落名称"
                    v-model="juLuoKeyWord"
                    clearable
                    style=""
                >
                    <el-button
                        slot="append"
                        @click="searchJuLuo()"
                        style="
                            background: #12c287;
                            color: white;
                            font-family: PingFangSC-Medium;
                            font-size: 16px;
                            color: #ffffff;
                            text-align: left;
                            line-height: 22px;
                            font-weight: 500;
                            height: 48px;
                        "
                        >搜索</el-button
                    >
                </el-input>
            </el-row>
            <!-- 厅县检索 -->
            <el-row style="margin: 25px 0px" v-if="juLuoKeyWord == ''">
                <el-col :span="3.5" style="text-align: left; line-height: 34px">
                    <span
                        style="
                            font-family: PingFangSC-Regular;
                            font-size: 16px;
                            color: #000000;
                            font-weight: 540;
                        "
                    >
                        所在厅县：</span
                    >
                </el-col>

                <el-col :span="5">
                    <el-input
                        size="medium"
                        :disabled="true"
                        v-model="selcetCountryName"
                        style="line-height: 20px"
                    ></el-input>
                </el-col>
                <el-col :span="1" style="margin-left: 10px">
                    <el-button
                        type="primary"
                        size="medium"
                        @click="dialogTableVisible = true"
                        >选择</el-button
                    >
                </el-col>
                <el-col :span="10" :offset="2">
                    <el-button-group>
                        <el-button
                            :type="primaryType[0]"
                            @click="changeFlagData(0)"
                        >
                            未定位
                            <span
                                v-if="selcetCountryName != '' && falgData == 0"
                                >{{ '（' + juLuoCount + '）' }}</span
                            >
                        </el-button>
                        <el-button
                            :type="primaryType[1]"
                            @click="changeFlagData(1)"
                        >
                            已定位<span
                                v-if="selcetCountryName != '' && falgData == 1"
                                >{{ '（' + juLuoCount + '）' }}</span
                            >
                        </el-button>
                    </el-button-group>
                </el-col>
            </el-row>

            <!-- 展示数据表格 -->
            <el-row
                v-if="juLuoKeyWord == ''"
                style="
                    margin-top: 0.6rem;
                    margin-right: 1.6rem;
                    margin-bottom: 0.6rem;
                "
            >
                <el-table
                    style="width: 100%"
                    max-height="40rem"
                    :row-style="{ height: 0 + 'px' }"
                    :cell-style="{ padding: 0 + 'px' }"
                    :data="currentPageData"
                    :header-cell-style="{
                        background: '#eef1f6',
                        color: '#606266',
                    }"
                >
                    <el-table-column
                        :index="indexMethod"
                        type="index"
                        label="序号"
                        width="60"
                    ></el-table-column>
                    <el-table-column
                        class="text-body"
                        label="聚落名称"
                        prop="name"
                    ></el-table-column>

                    <el-table-column
                        class="text-body"
                        label="记载方位"
                        width="160"
                        show-overflow-tooltip
                    >
                        <template slot-scope="scope">
                            {{ getRowfang(scope.row) }}
                        </template>
                    </el-table-column>
                    <el-table-column class="text-body" label="状态">
                        <template slot-scope="scope">
                            <div
                                v-if="
                                    scope.row.check_stat == null ||
                                    scope.row.check_stat == 2
                                "
                                style="color: red"
                            >
                                <div
                                    style="
                                        width: 8px;
                                        height: 8px;
                                        background: #ff3b30;
                                        border-radius: 50%;
                                        display: inline-block;
                                    "
                                ></div>
                                未定位
                            </div>
                            <div
                                v-if="scope.row.check_stat == 0"
                                style="color: orange"
                            >
                                <div
                                    style="
                                        width: 8px;
                                        height: 8px;
                                        background: orange;
                                        border-radius: 50%;
                                        display: inline-block;
                                    "
                                ></div>
                                待审核
                            </div>
                            <div
                                v-if="scope.row.check_stat == 1"
                                style="color: #1bc289"
                            >
                                <div
                                    style="
                                        width: 8px;
                                        height: 8px;
                                        background: #1bc289;
                                        border-radius: 50%;
                                        display: inline-block;
                                    "
                                ></div>
                                已定位
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <el-button
                                type="text"
                                v-if="
                                    scope.row.check_stat == null ||
                                    scope.row.check_stat == 2
                                "
                                @click="addNewLocation(scope.row)"
                                ><span
                                    style="
                                        border: 5px solid #1bc289;
                                        background: #1bc289;
                                        color: white;
                                    "
                                    >添加定位</span
                                >
                            </el-button>
                            <el-button
                                type="text"
                                v-if="
                                    scope.row.check_stat == 1 ||
                                    (scope.row.check_stat == 0 &&
                                        scope.row.user == getUser())
                                "
                                @click="viewJuLuo(scope.row)"
                                ><span
                                    style="
                                        border: 5px solid #1bc289;
                                        background: #1bc289;
                                        color: white;
                                    "
                                    >查看定位</span
                                ></el-button
                            >

                            <el-button
                                disabled
                                type="text"
                                title="该聚落是其他用户添加定位的，正在审核，不能查看。"
                                v-if="
                                    scope.row.check_stat == 0 &&
                                    scope.row.user != getUser()
                                "
                                ><span
                                    style="
                                        border: 5px solid #c3c5cc;
                                        background: #c3c5cc;
                                        color: white;
                                    "
                                    >查看定位</span
                                ></el-button
                            >
                        </template>
                    </el-table-column>
                </el-table>
                <div class="pagination_fa_div">
                    <el-pagination
                        background
                        layout="prev, pager, next"
                        :page-count="totalCount"
                        :current-page.sync="currentPageIndex"
                        @current-change="handlePageTurn"
                    >
                    </el-pagination>
                </div>
            </el-row>
            <!-- 搜索数据表格 -->
            <el-row
                v-if="juLuoKeyWord != ''"
                style="
                    margin-top: 0.6rem;
                    margin-right: 1.6rem;
                    margin-bottom: 0.6rem;
                "
            >
                <el-table
                    :header-cell-style="{
                        background: '#eef1f6',
                        color: '#606266',
                    }"
                    style="width: 100%"
                    max-height="40rem"
                    :data="
                        searchTotalData.slice(
                            (searchCurrentPageIndex - 1) * searchPageSize,
                            searchCurrentPageIndex * searchPageSize
                        )
                    "
                    :row-style="{ height: 0 + 'px' }"
                    :cell-style="{ padding: 0 + 'px' }"
                >
                    <el-table-column
                        :index="searchIndexMethod"
                        type="index"
                        label="序号"
                        width="60"
                    ></el-table-column>
                    <el-table-column
                        class="text-body"
                        label="聚落名称"
                        prop="name"
                    ></el-table-column>

                    <el-table-column
                        class="text-body"
                        label="记载方位"
                        width="160"
                        show-overflow-tooltip
                    >
                        <template slot-scope="scope">
                            {{ getRowfang(scope.row) }}
                        </template>
                    </el-table-column>
                    <el-table-column class="text-body" label="状态">
                        <template slot-scope="scope">
                            <div
                                v-if="
                                    scope.row.check_stat == null ||
                                    scope.row.check_stat == 2
                                "
                                style="color: red"
                            >
                                <div
                                    style="
                                        width: 8px;
                                        height: 8px;
                                        background: #ff3b30;
                                        border-radius: 50%;
                                        display: inline-block;
                                    "
                                ></div>
                                未定位
                            </div>
                            <div
                                v-if="scope.row.check_stat == 0"
                                style="color: green"
                            >
                                <div
                                    style="
                                        width: 8px;
                                        height: 8px;
                                        background: orange;
                                        border-radius: 50%;
                                        display: inline-block;
                                    "
                                ></div>
                                待审核
                            </div>
                            <div
                                v-if="scope.row.check_stat == 1"
                                style="color: green"
                            >
                                <div
                                    style="
                                        width: 8px;
                                        height: 8px;
                                        background: #1bc289;
                                        border-radius: 50%;
                                        display: inline-block;
                                    "
                                ></div>
                                已定位
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <el-button
                                type="text"
                                v-if="
                                    scope.row.check_stat == null ||
                                    scope.row.check_stat == 2
                                "
                                @click="addNewLocation(scope.row)"
                                ><span
                                    style="
                                        border: 5px solid #1bc289;
                                        background: #1bc289;
                                        color: white;
                                    "
                                    >添加定位</span
                                ></el-button
                            >
                            <el-button
                                type="text"
                                v-if="
                                    scope.row.check_stat == 1 ||
                                    (scope.row.check_stat == 0 &&
                                        scope.row.user == getUser())
                                "
                                @click="viewJuLuo(scope.row)"
                                ><span
                                    style="
                                        border: 5px solid #1bc289;
                                        background: #1bc289;
                                        color: white;
                                    "
                                    >查看定位</span
                                ></el-button
                            >

                            <el-button
                                disabled
                                type="text"
                                title="该聚落是其他用户添加定位的，正在审核，不能查看。"
                                v-if="
                                    scope.row.check_stat == 0 &&
                                    scope.row.user != getUser()
                                "
                            >
                                <span
                                    style="
                                        border: 5px solid #c3c5cc;
                                        background: #c3c5cc;
                                        color: white;
                                    "
                                    >查看定位</span
                                >
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="pagination_fa_div">
                    <el-pagination
                        background
                        layout="prev, pager, next"
                        :page-count="searchTotalCount"
                        :current-page.sync="searchCurrentPageIndex"
                        @current-change="searchHandlePageTurn"
                    >
                    </el-pagination>
                </div>
            </el-row>
        </div>
        <!-- 县厅检索 -->
        <el-dialog
            width="20%"
            style="text-align: left"
            title="请选择聚落的所在厅县"
            :append-to-body="true"
            :visible.sync="dialogTableVisible"
            class="dialog"
        >
            <comCountrySearch @changeCountry="changeCountry"></comCountrySearch>
        </el-dialog>
    </div>
</template>

<script>
import axios from 'axios'
import comCountrySearch from '@/V3/Main/Home/comCountrySearch.vue'

export default {
    components: {
        comCountrySearch,
    },
    data() {
        return {
            noSide: false,
            // 表格当前页的数据
            currentPageData: [],
            // 当前页的分页插件配置
            pageSize: 10,
            totalCount: 0,
            currentPageIndex: 1,

            // 全部页有几条数据
            juLuoCount: 0,

            // 当前展示什么样的数据
            falgData: 0,
            primaryType: ['primary', ''],
            CQL_FILTER:
                
                '!(check_stat == 0 or check_stat == 1)',

            // 选择的县
            selcetCountryName: '',
            dialogTableVisible: false,

            // 搜索keyword
            juLuoKeyWord: '',
            searchTotalData: [],
            searchPageSize: 10,
            searchTotalCount: 0,
            searchCurrentPageIndex: 1,

            // search 防抖
            searchTimer: '',

            // img
            clickflag: false,
        }
    },
    watch: {
        juLuoKeyWord: {
            deep: true,
            handler(newVal, oldVal) {
                this.debounce(this.searchJuLuo, 500)
            },
        },
    },
    beforeDestroy: function () {},
    computed: {},
    beforeMount: function () {
        if (this.$cookie.get('clickflag') != null) {
            this.clickflag = this.$cookie.get('clickflag')
        }
    },
    mounted() {
        this.getBatchData(0, 10, this.CQL_FILTER)
    },
    methods: {
        clickflaghandle() {
            this.clickflag = !this.clickflag
            this.$cookie.set('clickflag', this.clickflag)
        },
        //防抖
        debounce(fn, wait) {
            if (this.searchTimer !== null) {
                clearTimeout(this.searchTimer)
            }
            this.searchTimer = setTimeout(fn, wait)
        },
        // getUser() // 当前系统用户名
        getUser() {
            if (this.$cookie.get('mail') == null) {
                return this.$store.state.V3mail
            } else {
                return this.$cookie.get('mail')
            }
        },
        // 厅县选择变换
        changeCountry(data) {
            if (data.level == 3) {
                this.selcetCountryName = data.label
                // 未定位
                if (this.falgData == 0) {
                    this.CQL_FILTER =
                       
                        '!(check_stat == 0 or check_stat == 1)' +
                        ' and ' +
                        'lev2_name=' +
                        "'" +
                        this.selcetCountryName +
                        "'"
                } else if (this.falgData == 1) {
                    this.CQL_FILTER =
                      
                      '(check_stat == 0 or check_stat == 1)' +
                      ' and ' +
                        'lev2_name=' +
                        "'" +
                        this.selcetCountryName +
                        "'"
                }
                this.getBatchData(0, 10, this.CQL_FILTER)
            } else {
                this.selcetCountryName = ''
                this.changeFlagData(this.falgData)
            }
            this.currentPageIndex = 1
        },
        // 更改展示数据类型 未定位0 已定位1
        changeFlagData(value) {
            if (this.selcetCountryName == '') {
                this.primaryType = ['', '']
                this.primaryType[value] = 'primary'
                this.falgData = value
                if (value == 0) {
                    this.CQL_FILTER =
                      
                        '!(check_stat == 0 or check_stat == 1)'
                } else if (value == 1) {
                    this.CQL_FILTER =
                        '(check_stat == 0 or check_stat == 1)'
                        
                }
                this.getBatchData(0, 10, this.CQL_FILTER)
            } else {
                this.primaryType = ['', '']
                this.primaryType[value] = 'primary'
                this.falgData = value
                if (value == 0) {
                    this.CQL_FILTER =
                     
                        '!(check_stat == 0 or check_stat == 1)' +
                        ' and ' +
                        'lev2_name=' +
                        "'" +
                        this.selcetCountryName +
                        "'"
                } else if (value == 1) {
                    this.CQL_FILTER =
                     
                        '(check_stat == 0 or check_stat == 1)' +
                        ' and ' +
                        'lev2_name=' +
                        "'" +
                        this.selcetCountryName +
                        "'"
                }
                this.getBatchData(0, 10, this.CQL_FILTER)
            }
            this.currentPageIndex = 1
        },
        // 判断是否登录
        isLoginSuccess() {
            if (
                this.$cookie.get('isLogin') == 'success' ||
                this.$store.state.V3loginState == true
            ) {
                return true
            } else {
                return false
            }
        },
        // 拼接方位字段
        getRowfang(value) {
            let res = value.lev2_name 
            if(value.location != null){
                res +=  '，'

            }
            if (value.location != null) {
                res += value.location
            }
            if (value.distance != 0) {
                res += value.distance
                res += '里'
            }
            return res
        },
        indexMethod(index) {
            return (this.currentPageIndex - 1) * this.pageSize + index + 1
        },
        searchIndexMethod(index) {
            return (
                (this.searchCurrentPageIndex - 1) * this.searchPageSize +
                index +
                1
            )
        },
        // startIndex 从第几条数据开始获取
        // size 获取几条
        // CQL_FILTER 过滤条件
        getBatchData(startIndex, size, CQL_FILTER) {
            let url_params = {
                service: 'WFS',
                version: '1.0.0',
                request: 'GetFeature',
                typeName: 'lwdgis:v3data',
                outputFormat: 'application/json',
                sortBy: 'id',
                startIndex: startIndex,
                maxFeatures: size,
                CQL_FILTER: CQL_FILTER,
            }
            let self = this
            axios({
                url: $webConfig.V3.owsBaseURL,
                method: 'get',
                params: url_params,
            }).then((res) => {
                self.juLuoCount = res.data.totalFeatures
                self.totalCount = Math.ceil(
                    res.data.totalFeatures / self.pageSize
                )
                let resultTable = []

                res.data.features.forEach((item) => {
                    resultTable.push(item.properties)
                })
                self.currentPageData = resultTable
            })
        },

        // 翻页
        handlePageTurn(val) {
            this.currentPageIndex = val
            // 获取待定位
            this.getBatchData((val - 1) * this.pageSize, 10, this.CQL_FILTER)
        },
        searchHandlePageTurn(val) {
            this.searchCurrentPageIndex = val
        },

        // 搜索
        searchJuLuo() {
            let self = this
            let urlParams = {
                service: 'WFS',
                version: '1.0.0',
                request: 'GetFeature',
                typeName: 'lwdgis:v3data',
                outputFormat: 'application/json',
                sortBy: 'id',
                CQL_FILTER: 'name LIKE' + "'%" + this.juLuoKeyWord + "%'",
            }
            axios({
                url: $webConfig.V3.owsBaseURL,
                method: 'get',
                params: urlParams,
            }).then((res) => {
                self.searchTotalCount = Math.ceil(
                    res.data.totalFeatures / self.searchPageSize
                )
                let resultTable = []

                res.data.features.forEach((item) => {
                    resultTable.push(item.properties)
                })
                self.searchTotalData = resultTable
            })
        },

        // 点击添加定位
        addNewLocation(value) {
            if (this.isLoginSuccess()) {
                this.$emit('drawLocation', value)
            } else {
                this.$message({
                    message: '游客模式，无法添加定位，请先登录。',
                    type: 'error',
                })
            }
        },

        // 点击查看定位
        viewJuLuo(value) {
            this.$emit('viewLocation', value)
        },
    },
}
</script>

<style scoped>
.left {
    position: relative;
}
.left .switch {
    display: inline-block;
    position: absolute;
}
.ileft {
    right: -50px;
}
.iright {
    left: 1px;
}
.menu {
    transition: all 300ms;
}
.menu.noSide {
    display: none;
}

.clickfalsediv {
    width: 188px;
    height: 48px;
    opacity: 0.9;
    background: #ffffff;
    border-radius: 4px;
    cursor: pointer;
}
.clicktruediv {
    width: 188px;
    height: 48px;
    opacity: 0.9;
    cursor: pointer;
    background: #12c287;
    border-radius: 4px 4px 0px 0px;
}
.clickfalsespan {
    font-family: PingFangSC-Medium;
    font-size: 16px;
    color: #262626;
    text-align: left;
    line-height: 48px;
    font-weight: 550;
}
.clicktruespan {
    font-family: PingFangSC-Medium;
    font-size: 16px;
    color: #ffffff;
    text-align: left;
    line-height: 48px;
    font-weight: 550;
}

.left >>> .el-input-group > .el-input__inner {
    height: 48px;
}
.dialog >>> .el-dialog__header {
    background: #12c287 !important;
    padding: 20px 20px 20px !important;
}

.dialog >>> .el-dialog__title {
    font-family: PingFangSC-Medium;
    font-size: 18px;
    color: #ffffff;
    letter-spacing: 0;
    line-height: 22px;
    font-weight: 500;
}
.dialog >>> .el-dialog__close {
    /* color: #12C287; */
    color: white !important;
}
.dialog >>> .dialog__headerbtn:hover .el-dialog__close {
    /* color: #12C287; */
    color: white;
}
</style>


// WEBPACK FOOTER //
// src/V3/Main/Home/comLeftDraw.vue